import { useState } from 'react';
import { useLocalization } from '@/hooks/useLocalization';
import { useChat } from '@/hooks/useChat';
import { useWidget } from '@/state/WidgetContext';
import OptionButton from '@/components/OptionButton/OptionButton';
import styles from '@/styles/chat.module.scss';

const ErrorIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
  </svg>
);

export default function LeadErrorScreen() {
  const { t } = useLocalization();
  const { state } = useWidget();
  const { submitEmailInquiry, submitGuideEmail } = useChat();
  const [isRetrying, setIsRetrying] = useState(false);

  const handleRetry = async () => {
    setIsRetrying(true);
    try {
      if (state.user.channel === 'email') {
        await submitEmailInquiry();
      } else {
        await submitGuideEmail();
      }
    } finally {
      setIsRetrying(false);
    }
  };

  return (
    <div className={styles.offline}>
      <div className={styles.managerErrorHero}>
        <ErrorIcon />
      </div>
      <p className={styles.offlineMessage}>{t('leadError.message')}</p>
      <div className={styles.managerErrorAction}>
        <OptionButton
          variant="primary"
          onClick={handleRetry}
          disabled={isRetrying}
        >
          {isRetrying ? t('leadError.retrying') : t('leadError.retry')}
        </OptionButton>
      </div>
    </div>
  );
}
